import { create } from 'lodash';
// Interface đại diện cho từng giải thưởng trong xổ số
export interface IGiai {
    Key: string;
    So: string;
}

// Interface đại diện cho một đài (DaiID) trong miền (MB, MT, MN)
export interface IKetQua {
    DaiID: string;
    Giais: IGiai[];
}

// Interface đại diện cho một miền (Miền Bắc, Miền Trung, Miền Nam)
export interface IMien {
    KetQuas: IKetQua[];
}

// Interface tổng hợp chứa tất cả các miền
export interface IKetQuaXoSo {

    MB: IMien;
    MT: IMien;
    MN: IMien;

}

export function createEmptyKetQuaXoSo() {
    return {
        MB: { KetQuas: [] },
        MT: { KetQuas: [] },
        MN: { KetQuas: [] }
    };
}
export interface IKetQuaDisplayMn {
    G0: string[];
    G1: string[];
    G2: string[];
    G3: string[];
    G4: string[];
    G5: string[];
    G6: string[];
    G7: string[];
    G8: string[];
}
export function createEmptyKetQuaDisplayMn(): IKetQuaDisplayMn {
    return {
        G0: [],
        G1: [],
        G2: [],
        G3: [],
        G4: [],
        G5: [],
        G6: [],
        G7: [],
        G8: [],
    };
}